import 'extensions/ui-components/x-page-builder';

export default class PageBuilder {

	constructor () {
		this.init();
	}

	init () {
		this.initHeroVideos();
		this.initTabbedCarousel();
	}

	initTabbedCarousel () {
		import('./lib/components/x-carousel-image-card');
		import('./lib/components/x-carousel-title-card');
		import('extensions/ui-components/x-card');
		import('extensions/ui-components/x-product-card');
		import('extensions/ui-components/x-carousel');
		import('./lib/components/x-category-product-carousel');
		import('./lib/components/g-tabs');
	}

	async initHeroVideos () {
		const heroVideos = document.getElementsByClassName('js-component-hero-video');
		if (!heroVideos.length) {
			return;
		}

		const {default: HeroVideo} = await import('./lib/hero-video');

		new HeroVideo();
	}

}
